import { createFileRoute } from '@tanstack/react-router'
import { TaskDetailPage } from '../../../components/AdminTasks/TaskDetail'

export const Route = createFileRoute('/admin/tasks/$id/{-$tab}')({
  component: AdminTaskDetailRoute,
})

function AdminTaskDetailRoute() {
  const { id, tab } = Route.useParams()
  return <TaskDetailPage id={id} tab={tab} />
}
